import React, { useCallback, useMemo, useState } from "react";
import { Button, RadioGroup } from "@shoptet/ui";
import { useTranslation } from "react-i18next";
import {
  BiddingSchemeT,
  useChangeCampaignSettingsMutation,
  useOrganizationSettingsQuery,
} from "../../graphql/generated/graphql";
import { CheckmarkIcon } from "../Icons";
import { SmallLoader } from "../SmallLoader";

export const BiddingScheme = () => {
  const { t } = useTranslation("translation", { keyPrefix: "Components.AdvancedSetup" });
  const [value, setValue] = useState<BiddingSchemeT>(BiddingSchemeT.MaximizeConversionsValueT);
  const [isSaved, setIsSaved] = useState(false);

  const { data, loading } = useOrganizationSettingsQuery({
    onCompleted(dataResponse) {
      setValue(dataResponse.organization?.biddingScheme || BiddingSchemeT.MaximizeConversionsValueT);
    },
  });

  const [changeCampaignSetting, { loading: mutationLoading }] = useChangeCampaignSettingsMutation({
    onCompleted: () => {
      setIsSaved(true);
      setTimeout(() => setIsSaved(false), 2000);
    },
  });

  const onChange = useCallback(
    (newValue: BiddingSchemeT | null) => {
      if (newValue) {
        setValue(newValue);
      }
    },
    [setValue]
  );

  const options = useMemo(
    () => [
      { value: BiddingSchemeT.MaximizeConversionsValueT, label: t("Conversion value") },
      { value: BiddingSchemeT.MaximizeConversionsT, label: t("Conversions") },
    ],
    [t]
  );

  if (loading || !data?.organization) {
    return <SmallLoader />;
  }

  return (
    <div>
      <RadioGroup
        disabled={mutationLoading || isSaved}
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.value}
        name="bidding_schema"
        options={options}
        value={value}
        onChange={onChange}
      />
      {(data.organization?.biddingScheme === value && !mutationLoading && !isSaved && <span />) || (
        <div style={{ margin: "10px 10px 0 0" }}>
          <Button
            data-test-id="save-bidding-schema"
            disabled={mutationLoading || isSaved}
            variant="action"
            onClick={() => changeCampaignSetting({ variables: { biddingScheme: value } })}
          >
            {(isSaved && (
              <span style={{ display: "flex", alignItems: "center" }}>
                <CheckmarkIcon /> &nbsp; {t("Saved")}
              </span>
            )) ||
              (mutationLoading && t("Saving")) ||
              t("Save")}
          </Button>
        </div>
      )}
    </div>
  );
};
